module.exports = __webpack_public_path__ + "img/inner_enterprise_app.0f4182d2.png";